var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoreSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2E3B4E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "square-2",
    transform: "translate(9310.999 -133.082)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    className: "st0",
    d: "M-9239.2,150.33h-43.61c-6.04,0-10.95,4.9-10.95,10.95c0,0,0,0,0,0v43.61 c0,6.04,4.9,10.94,10.95,10.94h43.61c6.04,0,10.94-4.9,10.94-10.94c0,0,0,0,0,0v-43.6 C-9228.25,155.24-9233.15,150.34-9239.2,150.33C-9239.19,150.33-9239.19,150.33-9239.2,150.33z M-9240.16,200.47 c0,1.91-1.55,3.45-3.45,3.45h-34.77c-1.91,0-3.45-1.54-3.46-3.45V165.7c0-1.91,1.54-3.45,3.45-3.45c0,0,0,0,0,0h34.77 c1.91,0,3.45,1.55,3.45,3.45c0,0,0,0,0,0L-9240.16,200.47L-9240.16,200.47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    className: "st0",
    d: "M-9267.95,192.01c-1.1,0-1.99-0.9-1.98-1.99c0,0,0,0,0,0v-13.88c0-1.1,0.88-1.99,1.98-1.99 c0,0,0,0,0,0h13.9c1.1,0,1.98,0.89,1.98,1.99c0,0,0,0,0,0v13.88c0,1.1-0.88,1.99-1.98,1.99c0,0,0,0,0,0H-9267.95z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreSquare);
export default __webpack_public_path__ + "static/media/store-square.82ad00e1ea3420db9504ef8196579a02.svg";
export { ForwardRef as ReactComponent };